var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.viewData.loading
    ? _c("loading-list")
    : _c(
        "main",
        { staticClass: "col content-spacing", attrs: { role: "main" } },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
                      },
                      [
                        _c("h1", { staticClass: "h2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(`Dados ${_vm.state.name}`) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-breadcrumb", {
                        attrs: {
                          items: [
                            {
                              text: "Lista de Usuários",
                              href: "/#/consumers"
                            },
                            {
                              text: "Dados de um usuário",
                              href: "#",
                              active: true
                            }
                          ]
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.state
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _vm.state.firstApprovalSent
                            ? _c(
                                "b-card",
                                {
                                  staticStyle: { "margin-bottom": "10px" },
                                  attrs: { "header-tag": "header" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function() {
                                          return [
                                            _c("h6", { staticClass: "mb-0" }, [
                                              _vm._v(
                                                "\n              Cadastro básico\n              "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    float: "right"
                                                  },
                                                  attrs: {
                                                    href: "javascript:void(0);"
                                                  },
                                                  on: {
                                                    click: () =>
                                                      (_vm.viewData.showFirst = !_vm
                                                        .viewData.showFirst)
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.viewData.showFirst
                                                        ? "esconder"
                                                        : "mostrar"
                                                    )
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    413095657
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _vm.viewData.showFirst &&
                                  !_vm.state.firstApproval
                                    ? _c(
                                        "p",
                                        { staticClass: "card-text mt-2" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                type: "button",
                                                variant: "success"
                                              },
                                              on: {
                                                click: () =>
                                                  _vm.approve("First")
                                              }
                                            },
                                            [
                                              _c("b-icon-hand-thumbs-up"),
                                              _vm._v(" "),
                                              _vm.viewData.loadingFirst
                                                ? _c("i", {
                                                    staticClass:
                                                      "fas fa-spinner fa-spin pull-right"
                                                  })
                                                : _c("span", [
                                                    _vm._v("Aprovar")
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.state.secondApprovalSent
                            ? _c(
                                "b-card",
                                {
                                  staticStyle: { "margin-bottom": "10px" },
                                  attrs: { "header-tag": "header" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function() {
                                          return [
                                            _c("h6", { staticClass: "mb-0" }, [
                                              _vm._v(
                                                "\n              Cadastro avançado\n              "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    float: "right"
                                                  },
                                                  attrs: {
                                                    href: "javascript:void(0);"
                                                  },
                                                  on: {
                                                    click: () =>
                                                      (_vm.viewData.showSecond = !_vm
                                                        .viewData.showSecond)
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.viewData.showSecond
                                                        ? "esconder"
                                                        : "mostrar"
                                                    )
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    4156284771
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _vm.viewData.showSecond
                                    ? _c(
                                        "b-list-group",
                                        [
                                          _c("b-list-group-item", [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Foto do documento\n                "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      target: "_blank",
                                                      href:
                                                        _vm.state.documentUrl
                                                    }
                                                  },
                                                  [_vm._v("Ver em outra aba")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("p", [
                                              _c("img", {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  src: _vm.state.documentUrl
                                                }
                                              })
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("b-list-group-item", [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Selfie\n                "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      target: "_blank",
                                                      href: _vm.state.selfieUrl
                                                    }
                                                  },
                                                  [_vm._v("Ver em outra aba")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("p", [
                                              _c("img", {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  src: _vm.state.selfieUrl
                                                }
                                              })
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("b-list-group-item", [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                  "margin-bottom": "5px"
                                                }
                                              },
                                              [_vm._v("CEP")]
                                            ),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(_vm.state.zipCode) +
                                                "\n            "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-list-group-item", [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                  "margin-bottom": "5px"
                                                }
                                              },
                                              [_vm._v("Endereço")]
                                            ),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(_vm.state.address) +
                                                  " - " +
                                                  _vm._s(_vm.state.number) +
                                                  ", " +
                                                  _vm._s(_vm.state.city) +
                                                  " -\n                " +
                                                  _vm._s(_vm.state.state) +
                                                  " - " +
                                                  _vm._s(_vm.state.complement) +
                                                  "\n              "
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("b-list-group-item", [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                  "margin-bottom": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Nacionalidade / Profissão / Estado Civil\n              "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.state.nationality
                                                  ) +
                                                  " /\n                " +
                                                  _vm._s(
                                                    _vm.state.profession ||
                                                      "Não informado"
                                                  ) +
                                                  " /\n                " +
                                                  _vm._s(
                                                    _vm.getMaritalStatus(
                                                      _vm.state.maritalStatus
                                                    )
                                                  ) +
                                                  "\n              "
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("b-list-group-item", [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                  "margin-bottom": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Renda bruta mensal\n              "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      _vm.state.grossIncome
                                                    )
                                                  ) +
                                                  "\n              "
                                              )
                                            ])
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.viewData.showSecond &&
                                  !_vm.state.secondApproval
                                    ? _c(
                                        "p",
                                        { staticClass: "card-text mt-2" },
                                        [
                                          _c(
                                            "BaseButtonComponent",
                                            {
                                              attrs: {
                                                variant: "confirmation-action"
                                              },
                                              on: {
                                                click: () =>
                                                  _vm.approve("Second")
                                              }
                                            },
                                            [
                                              _c("b-icon-hand-thumbs-up"),
                                              _vm._v(" "),
                                              _vm.viewData.loadingSecond
                                                ? _c("i", {
                                                    staticClass:
                                                      "fas fa-spinner fa-spin pull-right"
                                                  })
                                                : _c("span", [
                                                    _vm._v("Aprovar")
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.state.finalApprovalSent
                            ? _c(
                                "b-card",
                                {
                                  staticStyle: { "margin-bottom": "10px" },
                                  attrs: {
                                    header: "Pagamento",
                                    "header-tag": "header"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function() {
                                          return [
                                            _c("h6", { staticClass: "mb-0" }, [
                                              _vm._v(
                                                "\n              Pagamento\n              "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    float: "right"
                                                  },
                                                  attrs: {
                                                    href: "javascript:void(0);"
                                                  },
                                                  on: {
                                                    click: () =>
                                                      (_vm.viewData.showFinal = !_vm
                                                        .viewData.showFinal)
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.viewData.showFinal
                                                        ? "esconder"
                                                        : "mostrar"
                                                    )
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3460746365
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _vm.viewData.showFinal
                                    ? _c(
                                        "b-list-group",
                                        [
                                          _c("b-list-group-item", [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                  "margin-bottom": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Usa boleto? / Cartão de crédito\n              "
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.state.useBankSlip
                                                    ? "Sim"
                                                    : "Não"
                                                ) +
                                                " /\n              " +
                                                _vm._s(_vm.state.creditCard) +
                                                "\n            "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.viewData.showFinal &&
                                  !_vm.state.finalApproval
                                    ? _c(
                                        "p",
                                        { staticClass: "card-text mt-2" },
                                        [
                                          _c(
                                            "BaseButtonComponent",
                                            {
                                              attrs: {
                                                variant: "confirmation-action"
                                              },
                                              on: {
                                                click: () =>
                                                  _vm.approve("Final")
                                              }
                                            },
                                            [
                                              _c("b-icon-hand-thumbs-up"),
                                              _vm._v(" "),
                                              _vm.viewData.loadingFinal
                                                ? _c("i", {
                                                    staticClass:
                                                      "fas fa-spinner fa-spin pull-right"
                                                  })
                                                : _c("span", [
                                                    _vm._v("Aprovar")
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }